import textoSemValor from './texto-sem-valor'
import filterEnum from './filterEnum'
import filterDate from './filterDate'
import filterDataHora from './filterDataHora'
import valorParaReal from './valor-para-real'
import formatarCpfCnpj from './formatarCpfCnpj'
import formatarTelefone from './formatarTelefone'
import formatarCEP from './formatarCEP'
import formatarBoolean from './formatarBoolean'
import filterTextoGrande from './filterTextoGrande'

export default {
    install(Vue) {
        Vue.filter('textoSemValor', textoSemValor)
        Vue.filter('filterEnum', filterEnum)
        Vue.filter('filterDate', filterDate)
        Vue.filter('filterDataHora', filterDataHora)
        Vue.filter('valorParaReal', valorParaReal)
        Vue.filter('formatarCpfCnpj', formatarCpfCnpj)
        Vue.filter('formatarTelefone', formatarTelefone)
        Vue.filter('formatarCEP', formatarCEP)
        Vue.filter('formatarBoolean', formatarBoolean)
        Vue.filter('filterTextoGrande', filterTextoGrande)
    }
}
